import { ERouting, PageSSR } from '@core/type';
import { FAQCategoryEntity } from '@core/type/api';

import { makeServerProps } from '../../helpers/make-server-props/make-server-props';
import { useSSRPage } from '../../hooks';
import { ViewContact } from '../../view';

export type ViewContactProps = PageSSR<{ faqQuestions?: FAQCategoryEntity }, unknown, unknown>;

const PageContact = (props: ViewContactProps) =>
  useSSRPage<{ faqQuestions?: FAQCategoryEntity }, unknown, unknown>({
    ...props,
    ViewPage: ({ faqQuestions }: ViewContactProps) => <ViewContact faqQuestions={faqQuestions} />,
  });

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.CONTACT,
});

export { getServerSideProps };

export default PageContact;
